$(document).ready(function() {
	if (typeof vehicleType !== 'undefined' && typeof isElectric !== 'undefined'
			&& typeof filterByBrand !== 'undefined' && typeof brandName !== 'undefined') {
		$.ajax({
			type: 'GET',
			url: '/tyre-ajax/topseller?vehicleType=' + encodeURIComponent(vehicleType) +
				"&isElectric=" + encodeURIComponent(isElectric) + "&filterByBrand=" + encodeURIComponent(filterByBrand) +
				"&brandName=" + encodeURIComponent(brandName),
			success: function (tyresCarouselProducts) {
				if (tyresCarouselProducts) {
					populateCarousel(tyresCarouselProducts);
				}
				ga360TopsellerProductImpressions(tyresCarouselProducts);
				window.localStorage.setItem('tyresCarouselProducts', JSON.stringify(tyresCarouselProducts));
			},
			error: function (xhr, ajaxOptions, thrownError) {
			}
		})
	}

    // Defining logic for the navigation items (left and right arrow)
	var previous = $('.tire_carousel .jcarousel-control-prev');
	var next = $('.tire_carousel .jcarousel-control-next');

	previous.on('jcarouselcontrol:active', function() {
			$(this).removeClass('inactive');
		})
		.on('jcarouselcontrol:inactive', function() {
			$(this).addClass('inactive');
		})
		.jcarouselControl({
			target: '-=1'
		});


	next.on('jcarouselcontrol:active', function() {
			$(this).removeClass('inactive');
		})
		.on('jcarouselcontrol:inactive', function() {
			$(this).addClass('inactive');
		})
		.jcarouselControl({
			target: '+=1'
		});
});


function populateCarousel(tyresCarouselProducts) {
	const carouselWidth = document.getElementById('homePageTopSellerCarousel').clientWidth;
	const buttonText = document.getElementById('detailsButtonText').value;

	var carouselContainer = $('#homePageTopSellerCarousel ul');
	carouselContainer.empty();

	var extraItemHtmlList = createElementForCarousel(carouselItems, buttonText);
	var totalItems = tyresCarouselProducts.length;
	var numLists = Math.ceil((totalItems + (extraItemHtmlList ? extraItemHtmlList.length : 0)) / 4);
	var numInserted = 0;

	for (var i = 0; i < numLists; i++) {
		var listHtml = '<li></li>';
		var listElement = $(listHtml);
		listElement.css('width', carouselWidth + 'px');

		// calculate the start index based on how many extra carousel element is inserted
		var startIdx = (i !== 0 && extraItemHtmlList) ? (i * 4 - numInserted) : (i * 4);

		// endIdx will remain the same, we always move the startIdx in case extra carousel items
		var endIdx = Math.min(startIdx + 4, totalItems);

		// check the carousel items an insert into the first place of the list
		if (i === 0 && extraItemHtmlList) {
			for (var index = 0; index < extraItemHtmlList.length; index++) {
				listElement.append(extraItemHtmlList[index]);
				endIdx--;
				numInserted++;
			}
		}

		for (var j = startIdx; j < endIdx; j++) {
			var carouselItemHtml = generateCarouselProductHtml(tyresCarouselProducts[j], buttonText);
			listElement.append(carouselItemHtml);
		}
		carouselContainer.append(listElement);
	}
	$('#homePageTopSellerCarousel').jcarousel();
}


function createElementForCarousel(carouselItems, buttonText) {
	var extraItemHtmlList = null;
	if (carouselItems) {
		extraItemHtmlList = []
		for (var i = 0; i < carouselItems.length; i++) {
			if (carouselItems[i].link.includes("/cw") && vehicleType === "PKW") {
				extraItemHtmlList.push(generateCarouselItemHtml(carouselItems[i], buttonText));
			}
		}
	}
	return extraItemHtmlList;
}


function generateCarouselItemHtml(carouselItem, buttonText) {
	var backgroundImageSeason = document.getElementById('backgroundImageSeason').value;
	var carouselItemHtml = '<div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 fl_item">';
	carouselItemHtml += '<a href="' + carouselItem.link + '">';
	carouselItemHtml += '<div class="fl_carousel_image_cw">';
	carouselItemHtml += '<img loading="lazy" src="' + backgroundImageSeason + '" alt="' + carouselItem.alt + '">';
	carouselItemHtml += '</div>';
	carouselItemHtml += '<div class="fl_carousel_caption">';
	carouselItemHtml += '<div class="tire_carousel_title_cw">';
	carouselItemHtml += '<span class="h4" style="font-weight: bold">' + carouselItem.title + '</span>';
	carouselItemHtml += '</div>';
	carouselItemHtml += '<div class="tire_carousel_product" >';
	carouselItemHtml += '<br><b>' + carouselItem.subtitle + '</b>';
	carouselItemHtml += '</div>';
	carouselItemHtml += '</div>';
	carouselItemHtml += '<span class="pure-button">' + buttonText + '</span>';
	carouselItemHtml += '</a>';
	carouselItemHtml += '</div>';
	return carouselItemHtml;
}

function generateCarouselProductHtml(item, buttonText) {
	var carouselItemHtml = '<div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 fl_item">';
	carouselItemHtml += '<a href="/product/' + item.code + '"   onclick="ga360TopsellerProductDetailsClick('+"'" + item.code + "'"+ ")" + '">';
	carouselItemHtml += '<div class="fl_carousel_image">';
	carouselItemHtml += '<img loading="lazy" src="' + item.imageLinkMedium + '" alt="' + item.brand.name + ' ' + item.name + '">';
	carouselItemHtml += '</div>';
	carouselItemHtml += '<div class="fl_carousel_caption">';
	carouselItemHtml += '<div class="tire_carousel_logo">';
	carouselItemHtml += '<img loading="lazy" src="' + item.brand.imageUrl + '" alt="' + item.brand.name + '">';
	carouselItemHtml += '</div>';
	carouselItemHtml += '<div class="tire_carousel_product">';
	carouselItemHtml += '<b>' + item.name + '</b><br>' + item.fullSize + '&nbsp;<b>' + (item.displayPrice || item.price).formattedValue + '</b>';
	carouselItemHtml += '</div>';
	carouselItemHtml += '</div>';
	carouselItemHtml += '<span class="pure-button">' + buttonText + '</span>';
	carouselItemHtml += '</a>';
	carouselItemHtml += '</div>';

	return carouselItemHtml;
}

function ga360TopsellerProductImpressions(tyresCarouselProducts) {
    const products = tyresCarouselProducts.map((product, index) =>
        generateData(product, index + 1)
    );
    const eventPayload = {
        event: "EECproductImpression",
        ecommerce: {
            currencyCode: window.pageData.siteCurrency,
            impressions: products
        }
    };
    dataLayer360.push(eventPayload);
}

function ga360TopsellerProductDetailsClick(productCode) {
    var list = "HomePage";
    var productData = ga360TopsellerGetProductData(productCode);
    var eventPayload = {
        event: "EECproductClick",
        ecommerce: {
            currencyCode: window.pageData.siteCurrency,
            click: {
                actionField: { list: list },
                products: productData
            }
        }
    };
    dataLayer360.push(eventPayload);
}

function ga360TopsellerGetProductData(productCode) {
    var impressions = JSON.parse(window.localStorage.getItem('tyresCarouselProducts'));
        for (var i = 0; i < impressions.length; i++) {
            if (impressions[i].code == productCode) {
            return generateData(impressions[i], i + 1);
           }
       }
    return '';
}

function generateData(data, position) {
    return {
        category: "Topseller : TyreProduct",
        list: "HomePage",
        id: data.code,
        brand: data.brand.name,
        name: data.name,
        variant: data.fullSize,
        price: validateDecimals(window.pageData.languageTag) ?
            data.price.value.toFixed(2) :
            data.price.value.toFixed(0),
        position: position,
        dimension60: "Car Tyre",
        dimension61: data.clientReviewsRating,
        dimension62: getStockLevel(data.deltiStock),
        dimension63: data.deltiStock,
        dimension64: data.code,
        dimension65: data.newFlag,
        dimension67: data.speedRating,
        dimension68: data.sprit + " | " + data.nass + " | " + data.sound1 + " dB"
    };
}

function validateDecimals(data) {
    if (data.includes("PL") ||
        data.includes("DK") ||
        data.includes("NO") ||
        data.includes("SE") ||
        data.includes("HU") ) {
            return false;
        }
    return true;
}

function getStockLevel(inStockLevel) {
    var inStockLevelLimit = $('#inStockLevelLimit').val()

    if (inStockLevel == 0) {
        return "Out of stock";
    } else if (inStockLevel < inStockLevelLimit) {
        return "Limited stock";
    } else if (inStockLevel >= inStockLevelLimit) {
        return "In stock"
    }
}